import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyEventRedirect = loadable(() => import(/* webpackChunkName: "content/eventredirect" */ './EventRedirect'));
